import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PORTFOLIO_FILTER_OPTIONS } from '@/lib/propertyPortfolio';

/**
 * The Non-Fund / Fund / Hilgard / Individual dropdown.
 *
 * One component for the Reports page and the Dashboard, for the same reason
 * ProjectTypeFilter is one: two copies are two places for the options to
 * drift apart.
 */
export default function PortfolioFilter({ value, onChange, className = 'w-40' }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className} aria-label="Filter by portfolio">
        <SelectValue placeholder="All Portfolios" />
      </SelectTrigger>
      <SelectContent>
        {PORTFOLIO_FILTER_OPTIONS.map(opt => (
          <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
